const namespace = 'bravissimo/redirect';

export const REDIRECT_CLIENT = `${namespace}/REDIRECT_CLIENT`;
